exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".arrowIndecator__upArrow___1f0sr{margin-top:0;margin-right:5px;right:20%}.arrowIndecator__downArrow___2LHKp,.arrowIndecator__upArrow___1f0sr{float:none;color:#004f5c!important;display:inline-block;position:relative}.arrowIndecator__downArrow___2LHKp{margin-top:2px;margin-right:-16%;right:7%}", ""]);

// exports
exports.locals = {
	"upArrow": "arrowIndecator__upArrow___1f0sr",
	"downArrow": "arrowIndecator__downArrow___2LHKp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/ExplorerTabContent/overrides/arrowIndecator.pcss
// module id = 883
// module chunks = 0